import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _arrayDynamicValue = { items: '_dynamicValue' };
var _dynamicValue = { map: '_mapDynamicValue', array: '_arrayDynamicValue' };
var _mapDynamicValue = { items: 'Map#_dynamicValue' };
var _notifyByAppRequest = { dynamicValues: 'Map#_dynamicValue' };
var _notifyByAppResponse = {};
var _notifyRequest = { dynamicValues: 'Map#_dynamicValue' };
var _notifyResponse = {};
var _resolveRequest = { dynamicValues: 'Map#_dynamicValue' };
var _resolveResponse = {};
function resolveComWixpressPingHubApiV3NotificationsServiceV3Url(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/notifications-hub-server',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/ping/hub',
                destPath: '',
            },
            {
                srcPath: '/_api/ping/notifications',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/ping/hub',
                destPath: '',
            },
            {
                srcPath: '/_api/ping/notifications',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/notifications/v3/notify',
                destPath: '/v3/notify',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Sends notifications based on the template and dynamic values provided.
 *
 * > This feature is not yet available to all users.
 *
 * An app can call this endpoint up to 100,000 times per month for each site.
 *
 * When you [create a notification template](https://dev.wix.com/api/rest/wix-notifications/notifications/creating-a-notification-template) in the Wix Dev Center, you are given a notification template ID.
 * Call the Notify endpoint with this ID as `notificationTemplateID` to trigger notifications based on the notification template.
 * If the notification template contains placeholders for dynamic values, provide those values as key-value pairs in the `dynamicValues` array.
 * The values you specify are incorporated seamlessly in the notifications sent out.
 */
export function notify(payload) {
    var _a = serializer(_notifyRequest, {
        _arrayDynamicValue: _arrayDynamicValue,
        _dynamicValue: _dynamicValue,
        _mapDynamicValue: _mapDynamicValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_notifyResponse, {}).fromJSON;
    function __notify(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.notifications.v3.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.hub.api.v3.NotificationsServiceV3.Notify',
            url: resolveComWixpressPingHubApiV3NotificationsServiceV3Url({
                protoPath: '/v3/notify',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __notify.fromReq = fromReq;
    __notify.__isAmbassador = true;
    return __notify;
}
/** NotifyByApp */
export function notifyByApp(payload) {
    var _a = serializer(_notifyByAppRequest, {
        _arrayDynamicValue: _arrayDynamicValue,
        _dynamicValue: _dynamicValue,
        _mapDynamicValue: _mapDynamicValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_notifyByAppResponse, {}).fromJSON;
    function __notifyByApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.notifications.v3.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.hub.api.v3.NotificationsServiceV3.NotifyByApp',
            url: resolveComWixpressPingHubApiV3NotificationsServiceV3Url({
                protoPath: '/v3/notify-by-app',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __notifyByApp.fromReq = fromReq;
    __notifyByApp.__isAmbassador = true;
    return __notifyByApp;
}
export function resolve(payload) {
    var _a = serializer(_resolveRequest, {
        _arrayDynamicValue: _arrayDynamicValue,
        _dynamicValue: _dynamicValue,
        _mapDynamicValue: _mapDynamicValue,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resolveResponse, {}).fromJSON;
    function __resolve(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ping.notifications.v3.notification',
            method: 'POST',
            methodFqn: 'com.wixpress.ping.hub.api.v3.NotificationsServiceV3.Resolve',
            url: resolveComWixpressPingHubApiV3NotificationsServiceV3Url({
                protoPath: '/v3/resolve',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resolve.fromReq = fromReq;
    __resolve.__isAmbassador = true;
    return __resolve;
}
//# sourceMappingURL=http.impl.js.map